// A deleted message keeps its place in the chat (owner decision, 24 Sep 2026),
// the way WhatsApp shows it, instead of vanishing and leaving the replies
// around it answering nothing.
//
// The API sends a TOMBSTONE for a deleted message: id, sender, time,
// deletedAt and deletedBy ("sender" or "admin"). Never its words or photo.
// Mirror of the API's MessageTombstoneRules and the app's
// message_tombstone.dart: change all three together.
//
// Pure, no Nuxt imports, so the unit tests import it directly.

export const DELETED_BY_SENDER = 'sender';
export const DELETED_BY_ADMIN = 'admin';

export const DELETED_TEXT = 'This message was deleted';
export const REMOVED_TEXT = 'This message was removed by an admin';

/** A message that has been deleted, by its sender or by an admin. */
export const isTombstone = (message) => !!message?.deletedAt;

/**
 * The line shown in the message's place. Anything that is not plainly an
 * admin removal reads as a deletion: the wording must never claim an admin
 * acted when nobody knows that they did.
 */
export const tombstoneText = (message) =>
    message?.deletedBy === DELETED_BY_ADMIN ? REMOVED_TEXT : DELETED_TEXT;

/**
 * What the device keeps for a message from the server. A live message as it
 * came; a tombstone with everything it once said wiped, so a copy held from
 * before the deletion (words, photo, caption) cannot survive it.
 */
export const toStoredMessage = (message) => {
    if (!isTombstone(message)) return message;
    return {
        ...message,
        content: '',
        messageType: 1,
        imageUploadId: null,
        imageFileName: null,
        imageWidth: null,
        imageHeight: null,
    };
};

/**
 * Messages from others newer than the read receipt (all of them without one).
 * A deleted message is never new: there is nothing in it to read.
 */
export const unreadCountOf = (messages, userId, readUpToTimestamp) => {
    const readUpTo = readUpToTimestamp ? new Date(readUpToTimestamp) : null;
    return (messages || []).filter(m => {
        if (m.senderUserId === userId) return false;
        if (isTombstone(m)) return false;
        return readUpTo == null || new Date(m.createdAt) > readUpTo;
    }).length;
};
